import type { BlockComponentProps } from '@unifyapps/carbon/no-code/components/BlockRenderer/types';
import { useRegistryContext } from '@unifyapps/carbon/no-code/context/RegistryProvider';
import { useBlockAppearanceStyles } from '@unifyapps/carbon/no-code/hooks/useBlockAppearanceStyles';
import { isEmptyBlock } from '@unifyapps/carbon/no-code/utils/block';
import type { DividerBlockStateType, DividerComponentType } from '@unifyapps/defs/types/blocks';
import { Divider as BaseDivider } from '@unifyapps/ui/components/Divider';
import { memo, useMemo } from 'react';

function Divider({
  attributesAndEventListeners,
  component,
  computedBlockState,
  dndRef,
}: BlockComponentProps<DividerComponentType, DividerBlockStateType, DividerBlockStateType>) {
  const { appearance } = computedBlockState;
  const { registry } = useRegistryContext();
  const BlockRenderer = registry.getBlockRenderer();

  const appearanceStyles = useMemo(() => {
    return {
      ...appearance?.styles,
      ...(appearance?.orientation === 'horizontal'
        ? { height: computedBlockState.appearance?.height }
        : { width: computedBlockState.appearance?.width }),
    };
  }, [appearance, computedBlockState.appearance?.width, computedBlockState.appearance?.height]);

  const { className, style } = useBlockAppearanceStyles({ appearanceStyles });

  return (
    <BaseDivider
      className={className}
      dividerType={appearance?.dividerStyle}
      orientation={appearance?.orientation}
      style={style}
      {...attributesAndEventListeners}
      ref={dndRef}
    >
      {component.slots?.body?.blockId && !isEmptyBlock(component.slots.body.blockId) ? (
        <BlockRenderer blockId={component.slots.body.blockId} parentBlockId={null} />
      ) : null}
    </BaseDivider>
  );
}

export default memo(Divider);
